'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M61.5 182.3l139.2-22.1 16.1-2.6c.8-1.6 14-27.4 39.5-77.3l0 313.6-108.1 55 22-139.2 2.5-16.1-11.5-11.5-99.6-99.7z', 'M138.4 304.7c-20.3 128.6-30.9 195.6-31.7 201.2 5-2.5 65.5-33.3 181.5-92.3l0-466.3c-16.6 32.5-47.4 92.9-92.6 181.4-128.6 20.4-195.6 31.1-201.1 32 3.9 3.9 51.9 52 143.9 144.1zm-77-122.3l139.2-22.1 16.1-2.6c.8-1.6 14-27.4 39.5-77.3l0 313.6-108.1 55 22-139.2 2.5-16.1-11.5-11.5-99.6-99.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;